<template>
  <card>
    <template v-slot>
      <div class="flex item-start">
        <div class="flex-shrink-0 content-center"><v-shield-check-outline></v-shield-check-outline></div>
        <div class="flex-1">
          <div class="text-2xl font-semibold leading-6 flex-1 mx-2">Inloggen in twee stappen (2FA) uitschakelen</div>
        </div>
      </div>
      <div class="grid my-2">
        <div class="w-1/3">
          <p>Er is een code verstuurd naar uw email. Vul deze hieronder in om het uit te schakelen.</p>
          <v-input-group-simple-2
            id="deauthorizationCode"
            v-model:value="deauthorizationCode"
            maxlength="6"
            placeholder="Uw verificatiecode"
            data-vv-as="Uw verificatiecode"
            :overwrite-value="deauthorizationCode"
            :rules="{
              required: false
            }"
            @input="saveInput($event)"
          />
          <small v-if="authenticationNotDisabled && !showResendText" class="text-red-700 block mx-2 my-4">
            De ingevoerde 2FA code is ongeldig
          </small>
          <small v-if="showResendText && !authenticationNotDisabled" class="text-red-700 block mx-2 my-4">
            Er is een nieuwe code verstuurd naar uw email.
          </small>
          <button
            @click.prevent="resendVerificationCode"
            class="flex justify-center py-2 px-2 md:px-4 border border-primary-color shadow-sm text-xs md:text-sm lg:text-sm font-medium text-primary-color bg-white rounded-full hover:bg-primary-default/50 items-center ml-1"
          >
            <span class="text-black underline font-normal">Code opnieuw versturen</span>
          </button>
        </div>
      </div>
      <div class="flex flex-row justify-end gap-4 mt-4">
        <a
          class="text-pdsPrimaryColor font-bold mt-2 cursor-pointer text-xs md:text-base"
          @click.prevent="closeEditAuthentication()"
        >
          Annuleren
        </a>
        <button
          :disabled="deauthorizationCode.length <= 5"
          @click.prevent="disable2FA()"
          class="flex justify-center p-2 md:px-4 text-xs md:text-base font-medium text-white items-center bg-cta rounded-full text-nowrap"
        >
          Bevestigen
        </button>
      </div>
    </template>
  </card>
</template>

<script>
import { tap } from 'rxjs/operators';
import VShieldCheckOutline from 'icons/ShieldCheckOutline';
import {
  currentUserIdentity$,
  disable2FactorAuthentication,
  twoFactorAuthenticationNotDisabledEvent$,
  twoFactorAuthenticationDisabledEvent$
} from '@/services';
import { ref, onMounted } from 'vue';

export default {
  name: 'PrescriberTwoFactorDisableAuthModal',
  components: { VShieldCheckOutline },
  setup() {
    const currentUserIdentity = ref(null);
    const twoFactorAuthenticationDisabledEvent = ref(null);
    const twoFactorAuthenticationNotDisabledEvent = ref(null);
    const deauthorizationCode = ref('');
    const authenticationNotDisabled = ref(null);
    const showResendText = ref(null);

    currentUserIdentity$.subscribe((value) => (currentUserIdentity.value = value));
    twoFactorAuthenticationDisabledEvent$.subscribe((value) => (twoFactorAuthenticationDisabledEvent.value = value));

    twoFactorAuthenticationNotDisabledEvent$.pipe(
      tap((e) => {
        this.deauthorizationCode = '';
        this.authenticationNotDisabled = true;
        this.showResendText = false;
      })
    );

    const saveInput = (event) => {
      deauthorizationCode.value = event.target.value;
    };

    onMounted(() => disable2FactorAuthentication());

    return {
      currentUserIdentity,
      twoFactorAuthenticationDisabledEvent,
      twoFactorAuthenticationNotDisabledEvent,
      deauthorizationCode,
      authenticationNotDisabled,
      showResendText,
      saveInput
    };
  },
  methods: {
    closeEditAuthentication() {
      this.$emit('closeEditAuthentication', false);
    },
    resendVerificationCode() {
      disable2FactorAuthentication();
      this.showResendText = true;
      this.authenticationNotDisabled = false;
    },
    async disable2FA() {
      await disable2FactorAuthentication(this.deauthorizationCode).then((response) => {
        if (response?.data?.length > 1) {
          this.closeEditAuthentication();
          this.$emit('success');
        } else {
          this.$emit('error');
        }
      });
    }
  }
};
</script>
